<p-table
  [value]="therapyPlans"
  showGridlines
  [rowHover]="true"
  [style]="{'cursor': 'pointer'}"
  [responsiveLayout]="'scroll'">

  <ng-template #header>
    <tr>
      <th>Zeitraum</th>
      <th>Titel</th>
      <th>Status</th>
    </tr>
  </ng-template>

  <ng-template
      #body
      let-therapy
      let-rowIndex="rowIndex">

    <tr
      (click)="routeToTherapyPlanDetails(therapy.id)"
      [attr.data-cy]="'sana-tp-client-therapy-plan-entry-' + rowIndex">
      <td>
        {{ therapy.startDate | date:'dd.MM.yyyy' }} - {{ therapy.endDate | date:'dd.MM.yyyy' }}
      </td>

      <td>
        {{ therapy.title }}
      </td>

      <td>
        <sana-tp-therapy-plan-status-tag
          [status]="therapy.status"></sana-tp-therapy-plan-status-tag>
      </td>
    </tr>
  </ng-template>
</p-table>
